import { SponsorLabReportActivityReport } from './sponsor-lab-report-activity-report';
import { CategoryNaturalKey } from '../../../documents';
import { ActivityReport } from '../../../shared';
import { SponsorLabManualActivityReport } from './sponsor-lab-manual-activity-report';
import { SponsorSiteCommunicationActivityReport } from './sponsor-site-communication-activity-report';
import { SponsorSiteActionActivityReport } from './sponsor-site-action-activity-report';
import { SponsorTrainingMaterialActivityReport } from './sponsor-training-material-activity-report';
import { ActivityReportEQuery } from '../../../admin/activity-reports/report-types/activity-report-e-query';

export function getSponsorActivityReportType(categoryId: CategoryNaturalKey): typeof ActivityReport {
    switch (categoryId) {
        case 'lab-manuals':
            return SponsorLabManualActivityReport;

        case 'result-alerts':
        case 'lab-reports':
            return SponsorLabReportActivityReport;

        case 'site-communications':
            return SponsorSiteCommunicationActivityReport;

        case 'site-actions':
            return SponsorSiteActionActivityReport;

        case 'training-materials':
            return SponsorTrainingMaterialActivityReport;

        case 'equery':
            return ActivityReportEQuery;

        default:
            throw new Error('Unknown activity report category');
    }
}